export const PATTERN_LIVE_CANDLE_WINDOW = 200;
